import { useScrollReveal } from '../../hooks/useScrollReveal';

const COMMUNITY_ITEMS = [
  {
    title: 'Discord',
    desc: 'Chat with players, find kingdoms, discuss strategy, and get help from the community.',
    link: 'Join the Discord \u2192',
    icon: (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#e0d5c8" strokeWidth="2">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    ),
  },
  {
    title: 'Dev Blog',
    desc: 'Follow development updates, balance changes, new features, and behind-the-scenes design decisions.',
    link: 'Read the blog \u2192',
    icon: (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#e0d5c8" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
];

export function CommunitySection() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="community" className="px-6 md:px-12 py-24 max-w-[1200px] mx-auto" ref={ref}>
      <div
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'opacity 0.6s ease, transform 0.6s ease',
        }}
      >
        <div
          className="mb-3 uppercase tracking-[0.15em]"
          style={{ fontFamily: "'Cinzel', serif", fontSize: 11, fontWeight: 600, color: '#a08030' }}
        >
          Join the Community
        </div>
        <h2
          className="mb-4"
          style={{ fontFamily: "'Cinzel', serif", fontSize: 36, fontWeight: 700, color: '#f0e8dc', lineHeight: 1.2 }}
        >
          Find Your Kingdom
        </h2>
        <p className="mb-12 max-w-[640px]" style={{ color: '#e0d5c8', fontSize: 18 }}>
          Strategy is better with allies. Connect with players, share tactics, and stay up to date.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {COMMUNITY_ITEMS.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-5 rounded-lg p-8"
              style={{
                background: '#1c1916',
                border: '1px solid #24201b',
              }}
            >
              <div
                className="flex items-center justify-center shrink-0 rounded-xl"
                style={{
                  width: 52,
                  height: 52,
                  background: '#0a0908',
                  border: '1px solid #2e2924',
                }}
              >
                {item.icon}
              </div>
              <div>
                <div
                  className="mb-1.5"
                  style={{ fontFamily: "'Cinzel', serif", fontSize: 18, fontWeight: 600, color: '#f0e8dc' }}
                >
                  {item.title}
                </div>
                <div className="mb-3" style={{ color: '#e0d5c8', fontSize: 15 }}>
                  {item.desc}
                </div>
                <a
                  href="#"
                  className="hover:underline"
                  style={{ color: '#6a9e8e', textDecoration: 'none', fontSize: 14, fontWeight: 600 }}
                >
                  {item.link}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
